export const type_nutrition = 'nutrition';
export const type_trials = 'trials';
export const product_items_per_request = 8;
